import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../constant";
import { toast } from "react-toastify";
import "../styles/Variable.css";
import "../styles/ManageMember.css";
import SideBar from "../components/SideBar";

const ManageBusinessTeamLeader = () => {
  const [seniorAgents, setSeniorAgents] = useState([]);
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedTeamLeaderId, setSelectedTeamLeaderId] = useState("");
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  
  const [leaderSearch, setLeaderSearch] = useState("");
  const [groupSearch, setGroupSearch] = useState("");
  const [editingTeam, setEditingTeam] = useState(null);
  
  const [viewHierarchyModal, setViewHierarchyModal] = useState(false);
  const [selectedTeamHierarchy, setSelectedTeamHierarchy] = useState([]);
  const [selectedTeamForHierarchy, setSelectedTeamForHierarchy] = useState(null);

  useEffect(() => {
    fetchAgents();
    fetchGroups();
    fetchTeams();
  }, []);

  const fetchAgents = async () => {
    try {
      const response = await axios.get(`${API_URL}/super-admin/senior-business-agent-groups/agents`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.data.success) {
        setSeniorAgents(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch agents", error);
      toast.error("Failed to load senior agents.");
    }
  };

  const fetchGroups = async () => {
    try {
      const response = await axios.get(`${API_URL}/super-admin/senior-business-agent-groups`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.data.success) {
        setAllGroups(response.data.data);
        // Filter out groups that are already Teams
        const normalGroups = response.data.data.filter(g => !g.team_leader_id);
        setGroups(normalGroups);
      }
    } catch (error) {
      console.error("Failed to fetch groups", error);
    }
  };

  const fetchTeams = async () => {
    try {
      const response = await axios.get(`${API_URL}/super-admin/senior-business-agent-groups/teams`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.data.success) {
        setTeams(response.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch teams", error);
    }
  };

  const handleGroupCheckboxChange = (groupId) => {
    if (selectedGroupIds.includes(groupId)) {
      setSelectedGroupIds(selectedGroupIds.filter(id => id !== groupId));
    } else {
      if (selectedGroupIds.length >= 20) {
        toast.warning("You can only select up to 20 groups for a team.");
        return;
      }
      setSelectedGroupIds([...selectedGroupIds, groupId]);
    }
  };

  const handleCreateTeam = async () => {
    if (!selectedTeamLeaderId) {
      toast.error("Please select a Team Leader.");
      return;
    }
    if (selectedGroupIds.length === 0) {
      toast.error("Please select at least one group.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/super-admin/senior-business-agent-groups/teams`, {
        team_leader_id: selectedTeamLeaderId,
        group_ids: selectedGroupIds
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.data.success) {
        toast.success("Team created successfully!");
        setSelectedTeamLeaderId("");
        setSelectedGroupIds([]);
        fetchGroups();
        fetchTeams();
      }
    } catch (error) {
      console.error("Failed to create team", error);
      toast.error(error.response?.data?.message || "Failed to create team.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTeam = async () => {
    if (!selectedTeamLeaderId) {
      toast.error("Please select a Team Leader.");
      return;
    }
    if (selectedGroupIds.length === 0) {
      toast.error("Please select at least one group.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.put(`${API_URL}/super-admin/senior-business-agent-groups/teams/${editingTeam.id}`, {
        team_leader_id: selectedTeamLeaderId,
        group_ids: selectedGroupIds
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.data.success) {
        toast.success("Team updated successfully!");
        setEditingTeam(null);
        setSelectedTeamLeaderId("");
        setSelectedGroupIds([]);
        fetchGroups();
        fetchTeams();
      }
    } catch (error) {
      console.error("Failed to update team", error);
      toast.error(error.response?.data?.message || "Failed to update team.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (team) => {
    setEditingTeam(team);
    setSelectedTeamLeaderId(String(team.team_leader_id));
    setSelectedGroupIds(team.child_groups ? team.child_groups.map(g => g.id) : []);
  };

  const handleCancelEdit = () => {
    setEditingTeam(null);
    setSelectedTeamLeaderId("");
    setSelectedGroupIds([]);
  };

  const handleViewHierarchy = (team) => {
    const teamFullGroups = (team.child_groups || []).map(cg => allGroups.find(g => g.id === cg.id)).filter(Boolean);
    setSelectedTeamHierarchy(teamFullGroups);
    setSelectedTeamForHierarchy(team);
    setViewHierarchyModal(true);
  };

  // Groups that are already in a team shouldn't be selectable unless we are editing that team
  const alreadyAssignedGroupIds = teams.reduce((acc, team) => {
    if (editingTeam && editingTeam.id === team.id) return acc;
    if (team.child_groups) {
      team.child_groups.forEach(g => acc.push(g.id));
    }
    return acc;
  }, []);

  return (
    <div className="manage-member-layout" style={{ display: 'flex', minHeight: '100vh' }}>
      <SideBar />
      <div className="main-content" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '20px', borderBottom: '1px solid #ddd' }}>
            <h2 style={{ margin: 0 }}>Assign Team Leader</h2>
        </div>
        
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', gap: '20px', marginBottom: '40px', height: '500px' }}>
            {/* Left Column: Select Team Leader */}
            <div style={{ flex: 1, backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ marginBottom: '15px' }}>Select Team Leader</h3>
              <input
                type="text"
                placeholder="Search by ID (e.g. S101) or Name..."
                value={leaderSearch}
                onChange={(e) => setLeaderSearch(e.target.value)}
                style={{ width: '95%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '10px' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, overflowY: 'auto', paddingRight: '5px' }}>
                {seniorAgents.filter(agent => 
                  (`BS${agent.agent_id+100}`.toLowerCase().includes(leaderSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(leaderSearch.toLowerCase()))
                ).map(agent => (
                  <div key={agent.user_id} style={{ display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', padding: '10px', borderRadius: '4px', backgroundColor: 'white' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: 'bold' }}>
                      <input
                        type="radio"
                        name="teamLeader"
                        checked={selectedTeamLeaderId === String(agent.user_id)}
                        onChange={() => setSelectedTeamLeaderId(String(agent.user_id))}
                        style={{ marginRight: '10px' }}
                      />
                      BS{agent.agent_id+100} - {agent.name}
                    </label>
                  </div>
                ))}
                {seniorAgents.filter(agent => 
                  (`BS${agent.agent_id+100}`.toLowerCase().includes(leaderSearch.toLowerCase()) || 
                   agent.name.toLowerCase().includes(leaderSearch.toLowerCase()))
                ).length === 0 && <p>No Senior Agents found matching search.</p>}
              </div>

            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
              {editingTeam ? (
                <>
                  <button onClick={handleUpdateTeam} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {loading ? 'Updating...' : 'Update Team'}
                  </button>
                  <button onClick={handleCancelEdit} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    Cancel
                  </button>
                </>
              ) : (
                selectedTeamLeaderId && (
                  <button onClick={handleCreateTeam} disabled={loading} style={{ padding: '10px 20px', backgroundColor: '#2D4CA8', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {loading ? 'Creating...' : 'Create Team'}
                  </button>
                )
              )}
            </div>
          </div>

            {/* Right Column: Select Groups for Team */}
            <div style={{ flex: 2, backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px solid #ddd', display: 'flex', flexDirection: 'column' }}>
              <h3 style={{ marginBottom: '15px' }}>Select Groups</h3>
              <input
                type="text"
                placeholder="Search by Group Name or Lead Agent..."
                value={groupSearch}
                onChange={(e) => setGroupSearch(e.target.value)}
                style={{ width: '95%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', marginBottom: '15px' }}
              />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, overflowY: 'auto', paddingRight: '5px' }}>
                {groups.filter(group => 
                  !alreadyAssignedGroupIds.includes(group.id) &&
                  (group.group_name.toLowerCase().includes(groupSearch.toLowerCase()) || 
                   (group.parent_agent_name && group.parent_agent_name.toLowerCase().includes(groupSearch.toLowerCase())))
                ).map(group => (
                  <div key={group.id} style={{ display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', padding: '10px', borderRadius: '4px', backgroundColor: 'white' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: 'bold' }}>
                      <input
                        type="checkbox"
                        checked={selectedGroupIds.includes(group.id)}
                        onChange={() => handleGroupCheckboxChange(group.id)}
                        disabled={!selectedGroupIds.includes(group.id) && selectedGroupIds.length >= 20}
                        style={{ marginRight: '10px' }}
                      />
                      {group.group_name} (Lead: {group.parent_agent_name}) - {group.members ? group.members.length : 0} Members
                    </label>
                  </div>
                ))}
                {groups.filter(group => 
                  !alreadyAssignedGroupIds.includes(group.id) &&
                  (group.group_name.toLowerCase().includes(groupSearch.toLowerCase()) || 
                   (group.parent_agent_name && group.parent_agent_name.toLowerCase().includes(groupSearch.toLowerCase())))
                ).length === 0 && <p>No Groups found matching search.</p>}
              </div>
            </div>
          </div>

          {/* List of created Teams */}
          <div>
            <h3>Existing Teams</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
              <thead>
                <tr style={{ backgroundColor: '#2D4CA8', color: 'white' }}>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Team Name</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Team Leader</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Assigned Groups</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {teams.map(team => (
                  <tr key={team.id}>
                    <td style={{ padding: '10px', border: '1px solid #ddd', fontWeight: 'bold' }}>
                      {team.group_name}
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                      {team.team_leader_agent_id ? `BS${team.team_leader_agent_id + 100}` : ''} - {team.team_leader_name}
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                      <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        {team.child_groups && team.child_groups.map(cg => (
                          <li key={cg.id}>{cg.group_name} (Lead: {cg.parent_agent_name}) - {cg.member_count} members</li>
                        ))}
                      </ul>
                    </td>
                    <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button 
                          onClick={() => handleViewHierarchy(team)}
                          style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.9em'
                          }}
                        >
                          View Hierarchy
                        </button>
                        <button 
                          onClick={() => handleEditClick(team)}
                          style={{
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.9em'
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </td>

                  </tr>
                ))}
                {teams.length === 0 && (
                  <tr>
                    <td colSpan="4" style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>No teams created yet.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal for viewing team hierarchy */}
      {viewHierarchyModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', 
          alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '8px', 
            width: '800px', maxWidth: '90%', maxHeight: '80vh', 
            display: 'flex', flexDirection: 'column'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', borderBottom: '1px solid #ddd', paddingBottom: '10px', marginBottom: '15px' }}>
              <div>
                <h3 style={{ margin: 0 }}>Team's Hierarchy</h3>
                
                <div style={{ display: 'flex', gap: '15px', marginTop: '12px', fontSize: '0.9em', color: '#555', fontWeight: 'bold' }}>
                  <span style={{ backgroundColor: '#e3f2fd', padding: '4px 8px', borderRadius: '4px', color: '#1565c0' }}>Groups: {selectedTeamHierarchy.length}</span>
                  <span style={{ backgroundColor: '#e8f5e9', padding: '4px 8px', borderRadius: '4px', color: '#2e7d32' }}>Total Senior Agents: {selectedTeamHierarchy.reduce((sum, g) => sum + (g.members ? g.members.length : 0), 0)}</span>
                  <span style={{ backgroundColor: '#fff3e0', padding: '4px 8px', borderRadius: '4px', color: '#e65100' }}>Total Mini Agents: {selectedTeamHierarchy.reduce((sum, g) => sum + (g.all_mini_agents ? g.all_mini_agents.length : 0), 0)}</span>
                  <span style={{ backgroundColor: '#f3e5f5', padding: '4px 8px', borderRadius: '4px', color: '#6a1b9a' }}>Total Retail Businesses: {selectedTeamHierarchy.reduce((sum, g) => sum + (g.all_mini_agents ? g.all_mini_agents.reduce((cSum, mini) => cSum + (mini.retail_businesses ? mini.retail_businesses.length : 0), 0) : 0), 0)}</span>
                </div>
                {selectedTeamForHierarchy && (
                  <h4 style={{ margin: '8px 0 0 0', color: '#2D4CA8' }}>
                    Team Leader: {selectedTeamForHierarchy.team_leader_agent_id ? `BS${selectedTeamForHierarchy.team_leader_agent_id + 100}` : ''} - {selectedTeamForHierarchy.team_leader_name}
                  </h4>
                )}
              </div>
              <button onClick={() => setViewHierarchyModal(false)} style={{ border: 'none', background: 'none', fontSize: '1.5em', cursor: 'pointer' }}>&times;</button>
            </div>
            
            <div style={{ flex: 1, overflowY: 'auto' }}>
              {selectedTeamHierarchy.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {selectedTeamHierarchy.map((group, gIndex) => (
                    <div key={gIndex} style={{ border: '2px solid #ccc', padding: '15px', borderRadius: '8px', backgroundColor: '#fdfdfd' }}>
                      <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>Group: {group.group_name} (Lead: BS{group.parent_agent_id + 100} - {group.parent_agent_name})</h3>
                      
                      {group.members && group.members.length > 0 ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                          {group.members.map((member, mIndex) => (
                            <div key={mIndex} style={{ border: '1px solid #ddd', padding: '10px', borderRadius: '6px', backgroundColor: '#fff' }}>
                              <h4 style={{ margin: '0 0 10px 0', color: '#2D4CA8' }}>Senior Agent: BS{member.agent_id + 100} - {member.name}</h4>
                              
                              {member.mini_agents && member.mini_agents.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingLeft: '20px' }}>
                                  {member.mini_agents.map((mini, miIndex) => (
                                    <div key={miIndex} style={{ borderLeft: '2px solid #eee', paddingLeft: '15px' }}>
                                      <h5 style={{ margin: '0 0 10px 0', color: '#4CAF50' }}>Mini Agent: BM{mini.agent_id + 100} - {mini.name}</h5>
                                      
                                      {mini.retail_businesses && mini.retail_businesses.length > 0 ? (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
                                          <thead>
                                            <tr style={{ backgroundColor: '#f5f5f5' }}>
                                              <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>Retail Business</th>
                                              {/* <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center', width: '120px' }}>Card Holder?</th> */}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {mini.retail_businesses.map((cust, cIndex) => (
                                              <tr key={cIndex}>
                                                <td style={{ padding: '6px', border: '1px solid #ddd' }}>{cust.name}</td>
                                                {/* <td style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center' }}>
                                                  {cust.is_card_holder ? (
                                                    <span style={{ color: 'white', backgroundColor: '#4CAF50', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em' }}>Yes</span>
                                                  ) : (
                                                    <span style={{ color: 'white', backgroundColor: '#f44336', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em' }}>No</span>
                                                  )}
                                                </td> */}
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <p style={{ fontSize: '0.9em', color: '#777', margin: 0 }}>0 retail businesses.</p>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <p style={{ fontSize: '0.9em', color: '#777', margin: 0, paddingLeft: '20px' }}>0 mini agents.</p>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>No members in this group.</p>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No hierarchy found for this team.</p>
              )}
            </div>
            
            <div style={{ marginTop: '15px', textAlign: 'right' }}>
              <button 
                onClick={() => setViewHierarchyModal(false)}
                style={{ backgroundColor: '#ccc', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageBusinessTeamLeader;
